import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import HeaderBread from "../../../components/HeaderBread";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import Layout from "../../../Layout";

import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";

import { message } from "antd";
import Swal from "sweetalert2";
import CustomizedTable from "../../../components/UI/CustomizedTable";
import DeletePop from "../../../constants/ErrorPermissionModal";
import { deleteAnnouncement, getAnnouncement, updateAnnouncement } from "../../../utils/ApiCalls/Announcement";
import { addlog } from "../../../utils/ApiCalls/Logs";
import { checkPermission } from "../../../utils/Validation/checkPermission";
import { LOG_ACTIONS } from "../../../utils/Constant/LogConstant.js";

const Announcement = () => {
  const navigate = useNavigate();
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "Announcement",
      route: "/website/cms/announcement",
    },
  ];
  const [rows, setRows] = useState([]);
  const [count, setCount] = useState(0);
  const [{ userDetails, permission }, dispatch] = useDataLayerValue();

  const location = useLocation();

  const [page, setPage] = useState(
    () => parseInt(new URLSearchParams(location.search).get("page")) || 1
  );
  const [pageSize, setPageSize] = useState(
    () => parseInt(new URLSearchParams(location.search).get("pageSize")) || 10
  );
  const [search, setSearch] = useState(
    () => new URLSearchParams(location.search).get("search") || ""
  );

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const pageParam = parseInt(params.get("page")) || 1;
    const pageSizeParam = parseInt(params.get("pageSize")) || 10;
    const searchParam = params.get("search") || "";

    // setPage(pageParam);
    // setPageSize(pageSizeParam);
    setSearch(searchParam);
  }, [location.search]);

  useEffect(() => {
    const params = new URLSearchParams();
    const currentParams = new URLSearchParams(location.search);

    params.set("page", page);
    params.set("pageSize", pageSize);
    if (search) params.set("search", search);

    if (currentParams.toString() !== params.toString()) {
      navigate({ search: params.toString() }, { replace: true });
    }
  }, [page, pageSize, search, navigate, location.search]);


  const columns = [
    {
      title: "Sl",
      width: 30,
      dataIndex: "id",
      key: "id",
      fixed: "left",
      render: (position, record, index) => ((page - 1) * pageSize) + index + 1,
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      width: 50,
    },
    {
      title: "Status",
      dataIndex: "is_active",
      key: "is_active",
      width: 30,
      sorter: (a, b) => "",
      render: (item, record, index) => (
        <div className="custom-control custom-switch">
          <input
            type="checkbox"
            checked={!!item}
            onChange={(value) => {
              try {
                if (new Date(record.valid_from) > new Date()) {
                  throw new Error(`Banner is not yet started`);
                }

                if (new Date(record.valid_to) < new Date()) {
                  throw new Error(`Banner is expired`);
                }
                handleUpdate(
                  record.id,
                  {
                    is_active: value.target.checked ? 1 : 0,
                  },
                  record.title
                );
              } catch (error) {
                dispatch({
                  type: "SET_LOADING",
                  loading: false,
                });

                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: error.message || "Unknown error occurred",
                });
              }
            }}
            className="custom-control-input"
            id={"customSwitch1" + index}
          />
          <label
            className="custom-control-label"
            style={{}}
            htmlFor={"customSwitch1" + index}
          ></label>
        </div>
      ),
    },
    {
      title: "Action",
      key: "operation",
      width: 100,
      render: (text, record) => (
        <div className="table_action_btn">
          <button className="btn" onClick={() => handleEdit(record.id)}>
            <i className="ri-edit-2-line" data-toggle="tooltip" title="Edit"></i>
          </button>
          <DeletePop onConfirm={() => handleDelete(record.id)}>
            <div>
              {" "}
              <button className="btn delete_btn">
                <i
                  className="ri-delete-bin-line"
                  data-toggle="tooltip"
                  title="Delete"
                ></i>
              </button>
            </div>
          </DeletePop>
        </div>
      ),
    },
  ];
  const handleUpdate = async (id, values, title) => {
    if (checkPermission(permission, "update_per", "Announcement",window?.location?.pathname)) {
      let data = await updateAnnouncement(id, values);
      if (data.error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: data.error,
        });
      } else {
        addlog(
          "Announcement " +
          (!values.valid_from
            ? values.is_active === 1
              ? LOG_ACTIONS.ACTIVATED
              : LOG_ACTIONS.DEACTIVATED
            : LOG_ACTIONS.UPDATED),
          "Announcement",
          { ...values, id, title },
          userDetails.id
        );
      }
      getData(page);
    } else {
      message.error("Update permission missing");
    }
  };
  useEffect(() => {
    getData(page);
  }, [page, pageSize]);

  const getData = async (value) => {
    let data = await getAnnouncement({ page: value, limit: pageSize });
    if (data.error)
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data.error, type: "error" },
      });
    else if (data.data) {
      setRows(data.data);
      setCount(data.count);
    }
  };
  const handleEdit = async (id) => {
    if (checkPermission(permission, "update_per", "Announcement",window?.location?.pathname)) {
      navigate("/website/cms/homepage/announcement/edit/" + id);
    } else {
      message.error("Update permission missing");
    }
  };
  const handleDelete = async (id) => {
    if (checkPermission(permission, "delete_per", "Announcement",window?.location?.pathname)) {
      deleteAnnouncement(id);
      getData();
    } else {
      message.error("Missing Permission for delete");
    }
  };



  return (
    <Layout type={"read_per"} module_data={"Announcement"}>
      <CustomHeaderTitle title={"Announcement"} />
      <div>
        <div>
          <HeaderBread
            navigation={navigation}
            title={"Announcement"}
          ></HeaderBread>
        </div>
        <section className="content" style={{ marginTop: "20px" }}>
          <div className="container-fluid">
            <div className="card">
              <div className="card-header two_item">
                <h5 className="card-title">Announcement List</h5>
                <div className="two_item">
                  <Link to="/website/cms/homepage/announcement/add" className="btn add_v_btn mx-2">
                    Add Announcement
                  </Link>


                </div>
              </div>
              <div className="card-body">
                <div className="table_holder">
                  <CustomizedTable
                    setRows={setRows}
                    setPageSize={setPageSize}
                    setPage={setPage}
                    pageSize={pageSize}
                    page={page}
                    count={count}
                    columns={columns}
                    rows={rows}
                    title={"Announcement"}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </Layout>
  );
};

export default Announcement;
